import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_413: DocMigration = {
  maxSchemaVersion: "0.0.413",
  description: "Remove any room layout entities from doc.entityGroups and clean up orphaned groups",
  apply(json: any) {
    // Keep track of which groups have entities removed
    const affectedGroupIds = new Set<string>();

    for (const id in json.entityRoomLayouts) {
      const hash = json.entityRoomLayouts[id];

      if (json.entityGroups[hash]) {
        const groupId = json.entityGroups[hash];
        affectedGroupIds.add(groupId);
        delete json.entityGroups[hash];
      }
    }

    // Create lookup table of groups that still have entities
    const activeGroups: Record<string, boolean> = {};
    for (const hash in json.entityGroups) {
      activeGroups[json.entityGroups[hash]] = true;
    }

    // Remove any affected groups that no longer have entities
    for (const groupId of affectedGroupIds) {
      if (!activeGroups[groupId]) {
        delete json.groups[groupId];
        delete json.entityRefs[groupId];
      }
    }

    return json;
  },
};

export default migration_0_0_413;
